import { render, staticRenderFns } from "./FailedLabels.vue?vue&type=template&id=c813d7ba&scoped=true"
import script from "./FailedLabels.vue?vue&type=script&lang=js"
export * from "./FailedLabels.vue?vue&type=script&lang=js"
import style0 from "./FailedLabels.vue?vue&type=style&index=0&id=c813d7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c813d7ba",
  null
  
)

export default component.exports